// @flow

import { WayfindingActions, SelectionActions } from "@adactive/arc-map";
import { ModalActions } from "@adactive/adsum-modal-asia";
import { DefaultSchemaHelper } from "@adactive/adsum-client-analytics";
import { ClientAPI as ACA } from "@adactive/adsum-utils";

const trackMapActions = (tracker, store, action) => {
  switch (action.type) {
    case "SET_WILL_TMTT": {
      const fromPlace = ACA.getPlace(action.payload.from.placeId);
      const toPlace = ACA.getPlace(action.payload.to.placeId);

      if (fromPlace) {
        tracker.add(
          DefaultSchemaHelper.getPlaceType(),
          DefaultSchemaHelper.getPlaceEvent("from", fromPlace)
        );
        const fromPois = ACA.getPoisFromPlace(fromPlace.id);
        if (fromPois && fromPois.length > 0) {
          const fromPoi = fromPois[0];
          tracker.add(
            DefaultSchemaHelper.getPoiType(),
            DefaultSchemaHelper.getPoiEvent("from", fromPoi)
          );
          if (
            fromPoi &&
            fromPoi.categories &&
            fromPoi.categories.length > 0 &&
            fromPoi.categories[0].id
          ) {
            const id = fromPoi.categories[0].id;
            const categories = ACA.getCategories([id]);
            if (categories && categories.length > 0) {
              categories.map((category) => {
                tracker.add(
                  DefaultSchemaHelper.getCategoryType(),
                  DefaultSchemaHelper.getCategoryEvent("from", category)
                );
                return category;
              });
            }
            if (
              fromPoi &&
              fromPoi.tags &&
              Array.from(fromPoi.tags.values).length > 0 &&
              Array.from(fromPoi.tags.values)[0].value
            ) {
              const id = Array.from(fromPoi.tags.values)[0].value;
              const tags = ACA.getTagBy({ id });
              if (tags && tags.length > 0) {
                tags.map((tag) => {
                  tracker.add(
                    DefaultSchemaHelper.getTagType(),
                    DefaultSchemaHelper.getTagEvent("from", tag)
                  );
                  return tag;
                });
              }
            }
          }
        }
      }

      if (toPlace) {
        tracker.add(
          DefaultSchemaHelper.getPlaceType(),
          DefaultSchemaHelper.getPlaceEvent("goTo", toPlace)
        );
        const toPois = ACA.getPoisFromPlace(toPlace.id);
        if (toPois && toPois.length > 0) {
          const toPoi = toPois[0];
          tracker.add(
            DefaultSchemaHelper.getPoiType(),
            DefaultSchemaHelper.getPoiEvent("goTo", toPoi)
          );
          if (
            toPoi &&
            toPoi.categories &&
            toPoi.categories.length > 0 &&
            toPoi.categories[0].id
          ) {
            const id = toPoi.categories[0].id;
            const categories = ACA.getCategories([id]);
            if (categories && categories.length > 0) {
              categories.map((category) => {
                tracker.add(
                  DefaultSchemaHelper.getCategoryType(),
                  DefaultSchemaHelper.getCategoryEvent("goTo", category)
                );
                return category;
              });
            }
            if (
              toPoi &&
              toPoi.tags &&
              Array.from(toPoi.tags.values).length > 0 &&
              Array.from(toPoi.tags.values)[0].value
            ) {
              const id = Array.from(toPoi.tags.values)[0].value;
              const tags = ACA.getTagBy({ id });
              if (tags && tags.length > 0) {
                tags.map((tag) => {
                  tracker.add(
                    DefaultSchemaHelper.getTagType(),
                    DefaultSchemaHelper.getTagEvent("goTo", tag)
                  );
                  return tag;
                });
              }
            }
          }
        }
      }
      break;
    }

    case "SET_SELECTED_POI": {
      const { payload } = action;
      if (payload && payload.name) {
        const place = payload.locations.length > 0 && payload.locations[0];
        if (place !== null) {
          tracker.add(
            DefaultSchemaHelper.getPlaceType(),
            DefaultSchemaHelper.getPlaceEvent("select", place)
          );
        }
        const poi = payload;
        tracker.add(
          DefaultSchemaHelper.getPoiType(),
          DefaultSchemaHelper.getPoiEvent("select", poi)
        );
        if (
          poi &&
          poi.categories &&
          poi.categories.length > 0 &&
          poi.categories[0].id
        ) {
          const id = poi.categories[0].id;
          const categories = ACA.getCategories([id]);
          if (categories && categories.length > 0) {
            categories.map((category) => {
              tracker.add(
                DefaultSchemaHelper.getCategoryType(),
                DefaultSchemaHelper.getCategoryEvent("select", category)
              );
              return category;
            });
          }
        }
        if (
          poi &&
          poi.tags &&
          Array.from(poi.tags.values).length > 0 &&
          Array.from(poi.tags.values)[0].value
        ) {
          const id = [Array.from(poi.tags.values)[0].value];
          const tags = ACA.getTagBy({ id });
          if (tags && tags.length > 0) {
            tags.map((tag) => {
              tracker.add(
                DefaultSchemaHelper.getTagType(),
                DefaultSchemaHelper.getTagEvent("select", tag)
              );
              return tag;
            });
          }
        }
      }
      break;
    }

    case "SET_SELECTED_POI_FROM_DIRECTORY": {
      const { payload } = action;
      if (payload && payload.name) {
        const place = payload.locations.length > 0 && payload.locations[0];
        if (place !== null) {
          tracker.add(
            DefaultSchemaHelper.getPlaceType(),
            DefaultSchemaHelper.getPlaceEvent("select2", place)
          );
        }
        const poi = payload;
        tracker.add(
          DefaultSchemaHelper.getPoiType(),
          DefaultSchemaHelper.getPoiEvent("select2", poi)
        );
        if (
          poi &&
          poi.categories &&
          poi.categories.length > 0 &&
          poi.categories[0].id
        ) {
          const id = poi.categories[0].id;
          const categories = ACA.getCategories([id]);
          if (categories && categories.length > 0) {
            categories.map((category) => {
              tracker.add(
                DefaultSchemaHelper.getCategoryType(),
                DefaultSchemaHelper.getCategoryEvent("select2", category)
              );
              return category;
            });
          }
        }
        if (
          poi &&
          poi.tags &&
          Array.from(poi.tags.values).length > 0 &&
          Array.from(poi.tags.values)[0].value
        ) {
          const id = [Array.from(poi.tags.values)[0].value];
          const tags = ACA.getTagBy({ id });
          if (tags && tags.length > 0) {
            tags.map((tag) => {
              tracker.add(
                DefaultSchemaHelper.getTagType(),
                DefaultSchemaHelper.getTagEvent("select", tag)
              );
              return tag;
            });
          }
        }
      }
      break;
    }

    case "SET_SELECTED_MEDIA":
      const adsumObject = action.payload;
      const mediaAnalyticObject = {
        id: adsumObject._id,
        name: adsumObject.name,
      };

      tracker.add(
        DefaultSchemaHelper.getMediaType(),
        DefaultSchemaHelper.getMediaEvent("select", mediaAnalyticObject)
      );
      break;
    default:
  }
};

export default trackMapActions;
